module.exports = __webpack_public_path__ + "static/media/HCMM194.b1f44fd6.jpg";